/*
 * Carrusel de cards de expertas.
 * Móvil / tablet: se ve una card, pasa sola en bucle y se puede mover con el dedo (o el ratón) hacia la siguiente y la
 * anterior, sin fin en los dos sentidos. Debajo van los puntos de navegación (el activo es una píldora). Con 1400px o más
 * el CSS reparte todas las cards a lo ancho y aquí se para el movimiento.
 * Ligero: solo se mueve `transform`, los eventos son pasivos, el autoavance se pausa si la sección no está en pantalla
 * o la pestaña está oculta, y no hay librerías.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.hmBound === '1') return;
    var track = root.querySelector('[data-hm-ex-track]');
    if (!track) return;
    var items = [].slice.call(track.children);
    var count = items.length;
    if (count < 2) return;
    root.dataset.hmBound = '1';

    var wide = window.matchMedia('(min-width: 1400px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inColumn = !!root.closest('.hm-in-column');
    var every = (parseFloat(root.getAttribute('data-interval')) || 6) * 1000;

    // Copia de la última al principio y de la primera al final: se puede avanzar o retroceder sin fin y, al llegar a una
    // copia, se salta sin que se note a la card real equivalente.
    function makeClone(src) {
      var c = src.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.classList.add('hm-ex__item--clone');
      [].forEach.call(c.querySelectorAll('a, button, [tabindex]'), function (e) { e.setAttribute('tabindex', '-1'); });
      return c;
    }
    track.insertBefore(makeClone(items[count - 1]), track.firstChild);
    track.appendChild(makeClone(items[0]));
    [].forEach.call(track.querySelectorAll('img'), function (img) { img.setAttribute('draggable', 'false'); });

    var pos = 1; // posición visual: 0 = copia de la última, 1..count = cards reales, count+1 = copia de la primera
    var timer = null;
    var wrapTimer = null;
    var visible = true;
    var dragging = false;

    function mode() {
      return (wide.matches && !inColumn) || reduce.matches ? 'static' : 'carousel';
    }

    // Puntos de navegación
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'hm-ex__dots';
    dotsWrap.setAttribute('role', 'group');
    var dots = items.map(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hm-ex__dot';
      var nm = it.querySelector('.hm-ex__name');
      b.setAttribute('aria-label', nm ? nm.textContent.trim() : String(i + 1));
      b.setAttribute('aria-pressed', 'false');
      b.addEventListener('click', function () { go(i + 1); restart(); });
      dotsWrap.appendChild(b);
      return b;
    });
    root.parentNode.appendChild(dotsWrap);

    function paintDots() {
      var real = ((pos - 1) % count + count) % count;
      dots.forEach(function (d, i) { d.setAttribute('aria-pressed', i === real ? 'true' : 'false'); });
    }

    function place(p, animate, quick) {
      track.style.transition = animate ? (quick ? 'transform .45s cubic-bezier(.22,1,.36,1)' : '') : 'none';
      track.style.transform = 'translateX(' + -p * 100 + '%)';
      pos = p;
      paintDots();
    }

    // Si se ha llegado a una copia, se salta (sin animación) a la card real equivalente.
    function wrap() {
      if (pos === 0) { place(count, false); void track.offsetWidth; }
      else if (pos === count + 1) { place(1, false); void track.offsetWidth; }
    }

    function armWrap(ms) {
      window.clearTimeout(wrapTimer);
      wrapTimer = window.setTimeout(wrap, ms);
    }

    function go(p) {
      wrap();
      place(Math.max(0, Math.min(count + 1, p)), true, true);
      armWrap(700);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform' && !dragging) wrap();
    });

    function tick() {
      if (!visible || document.hidden || dragging) return;
      wrap();
      place(pos + 1, true, false);
      armWrap(900);
    }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }
    function restart() {
      stop();
      if (mode() === 'carousel') timer = window.setInterval(tick, every);
    }

    // Arrastre con el dedo: solo horizontal (la página sigue desplazándose en vertical).
    var sx = 0, sy = 0, st = 0, base = 0, w = 1, pid = null, maybe = false;
    function matrixX() {
      try { return new DOMMatrix(getComputedStyle(track).transform).m41; } catch (e) { return -pos * w; }
    }
    function onDown(e) {
      if (mode() !== 'carousel' || (e.pointerType === 'mouse' && e.button !== 0)) return;
      w = root.offsetWidth || 1;
      wrap();
      sx = e.clientX; sy = e.clientY; st = e.timeStamp; pid = e.pointerId; maybe = true;
      base = matrixX();
    }
    function onMove(e) {
      if (!maybe || e.pointerId !== pid) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!dragging) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { maybe = false; return; }
        if (Math.abs(dx) < 6) return;
        dragging = true;
        stop();
        track.style.transition = 'none';
        try { root.setPointerCapture(pid); } catch (err) {}
        root.classList.add('is-dragging');
      }
      track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    }
    function onUp(e) {
      if (!maybe || e.pointerId !== pid) return;
      maybe = false;
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-dragging');
      try { root.releasePointerCapture(pid); } catch (err) {}
      var dx = e.clientX - sx;
      var v = dx / Math.max(1, e.timeStamp - st); // px/ms
      var f = -(base + dx) / w;                    // posición fraccionaria actual
      var far = Math.abs(dx) > Math.max(40, w * 0.18) || Math.abs(v) > 0.4;
      var p = far ? (dx < 0 ? Math.floor(f) + 1 : Math.ceil(f) - 1) : Math.round(f);
      place(Math.max(0, Math.min(count + 1, p)), true, true);
      armWrap(700);
      restart();
    }
    root.addEventListener('pointerdown', onDown, { passive: true });
    root.addEventListener('pointermove', onMove, { passive: true });
    root.addEventListener('pointerup', onUp, { passive: true });
    root.addEventListener('pointercancel', onUp, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.1 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) wrap(); });

    function start() {
      stop();
      if (mode() === 'static') {
        track.style.transition = 'none';
        track.style.transform = '';
        pos = 1;
        dotsWrap.hidden = true;
        return;
      }
      dotsWrap.hidden = false;
      place(1 + Math.floor(Math.random() * count), false);
      void track.offsetWidth;
      restart();
    }

    if (wide.addEventListener) {
      wide.addEventListener('change', start);
      reduce.addEventListener('change', start);
    }
    start();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hm-expertas]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
